export default "__VITE_PUBLIC_ASSET__5536b843__"